import { useState, useEffect, useRef } from 'react';
import styles from './Partner.module.css';
import monadLogo from '../../../../assets/MonadLogo.svg';
import GoogleCloudLogo from '../../../../assets/GoogleCloudLogo.png';
import solanaLogo from '../../../../assets/solanaLogo.png';
import depinUnionLogo from '../../../../assets/depinUnionLogo.svg';
import oortLogo from '../../../../assets/oortLogo.png';

const Partner = () => {
  const [offset, setOffset] = useState(0);
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const requestRef = useRef();

  const speed = 30;

  const partners = [
    { name: 'Monad 1', logo: monadLogo },
    { name: 'Google Cloud', logo: GoogleCloudLogo },
    { name: 'Solana', logo: solanaLogo },
    { name: 'Depin Union', logo: depinUnionLogo },
    { name: 'Oort', logo: oortLogo },
    { name: 'Google Cloud', logo: GoogleCloudLogo },
    { name: 'Oort', logo: oortLogo },
  ];

  const animate = (time) => {
    if (!containerRef.current || !trackRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    const trackWidth = trackRef.current.scrollWidth / 2; 

    let newOffset = offset - (speed * 16) / 1000; 
    if (Math.abs(newOffset) >= trackWidth) {
      newOffset = 0;
    }

    setOffset(newOffset);
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [offset]);

  return (
    <section className={styles.carouselSection}>
      <div className={styles.carouselContainer} ref={containerRef}>
        <div
          ref={trackRef}
          className={styles.carouselTrack}
          style={{ transform: `translateX(${offset}px)` }}
        >
          {partners.map((partner, index) => (
            <div key={index} className={styles.partnerItem}>
              <img
                src={partner.logo}
                alt={partner.name}
                className={styles.partnerLogo}
              />
            </div>
          ))}
          {partners.map((partner, index) => (
            <div key={`clone-${index}`} className={styles.partnerItem}>
              <img
                src={partner.logo}
                alt={partner.name}
                className={styles.partnerLogo}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partner;